import React from 'react'
import Layout from '../../layout'

function Orgs() {
  return (
    <>
        <Layout props='organizations'></Layout>
    </>
  )
}

export default Orgs